import React from 'react';
import { Box, Popover } from '@mui/material';
import { StaticDatePicker } from '@mui/x-date-pickers/StaticDatePicker';

const SetDatesPopover = ({ anchorEl, isOpen, value, onClose, onApply }) => {
  return (
    <Popover
      open={isOpen}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
    >
      <Box sx={{ p: 1 }}>
        <StaticDatePicker
          value={value}
          onChange={onApply}
          slotProps={{
            actionBar: { actions: ['today'] },
          }}
        />
      </Box>
    </Popover>
  );
};

export default SetDatesPopover;
